import React from 'react';
import { useForm } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import YFTextArea from '../elements/YFTextArea';
import { useApiCall } from '../../api/apiCallHook';
import { submitContactUs } from '../../api';
import { Row, Col, Alert } from 'antd';
import Loading from '../../components/Loading';

const ContactForm = () => {
    const { handleSubmit, register, errors } = useForm();
    const onSubmit = (value) => {
        execute({ request: value });
    };

    const { execute, pending, value, error } = useApiCall(submitContactUs, false);

    return (
        <form test_id="contact_form" className="solutionForBusinessFormContainer" onSubmit={handleSubmit(onSubmit)}>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        test_id="contact_form_name"
                        name="name"
                        type="text"
                        label="Full Name"
                        placeholder="Enter Full Name"
                        register={register({ required: true })}
                    />
                    <div className="form-error">
                        {/* {errors.name && <span>Name Required</span>}
                         */}
                        {/* {errors.full_name && <Alert type="error" showIcon message="Name Required" />} */}
                        {errors.full_name && <span className="formFieldError">Please enter your name.</span>}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        test_id="contact_form_email"
                        name="email"
                        type="email"
                        label="Email"
                        placeholder="Enter Email"
                        register={register({
                            required: true,
                            pattern:
                                /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        })}
                    />
                    {/* <div className="form-error"> */}
                    {/* {errors.email?.type === 'required' && <Alert type="error" showIcon message="Email Required" />} */}
                    {errors.email?.type === 'required' && (
                        <span className="formFieldError">Please enter your email.</span>
                    )}
                    {/* {errors.email?.type === 'pattern' && <Alert type="error" showIcon message="Invalid email format." />} */}
                    {errors.email?.type === 'pattern' && <span className="formFieldError">Invalid email address.</span>}
                    {/* </div> */}
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        test_id="contact_form_phone"
                        name="phone"
                        type="number"
                        min="0"
                        step="0"
                        label="Phone Number"
                        placeholder="Enter Phone number"
                        register={register({ required: true })}
                    />
                    {/* {errors.contact_number && <Alert type="error" showIcon message="Phone Number Required" />} */}
                    {errors.contact_number && <span className="formFieldError">Please enter your phone.</span>}
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        test_id="contact_form_subject"
                        name="subject"
                        type="text"
                        label="Subject"
                        placeholder="Enter Subject"
                        register={register({ required: false })}
                    />
                    {/* {errors.subject && <Alert type="error" showIcon message="Subject Required" />} */}
                    {errors.subject && <span className="formFieldError">Please enter subject.</span>}
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFTextArea
                        test_id="contact_form_message"
                        name="message"
                        type="text"
                        label="Your Message"
                        placeholder="Enter Message"
                        register={register({ required: true })}
                    />
                    {/* {errors.message && <Alert type="error" showIcon message="Message Required" />} */}
                    {errors.message && <span className="formFieldError">Please enter message.</span>}
                </Col>
            </Row>
            <div>
                {value !== null && <Alert type="success" message={value.message} />}
                {error !== null && <Alert type="error" message={error.response.data.errors?.email[0]} />}
                {pending ? <Loading /> : <input test_id="contact_form_submit" type="submit" label="Submit" />}
                {/* <input type="submit" label="Submit" /> */}
            </div>
        </form>
    );
};

export default ContactForm;
